// Admin Panel Page for AAR Guest Management System
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, getUserRole } from '../firebase/authService';
import { canAccessAdmin } from '../utils/roles';
import '../styles/AdminPanel.css';

const AdminPanel = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = getCurrentUser();

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }

    getUserRole(user.uid).then(role => {
      if (!canAccessAdmin(role)) {
        navigate('/dashboard');
      } else {
        setLoading(false);
      }
    });
  }, [user, navigate]);


  if (loading) {
    return (
      <div className="loading"><div className="spinner"></div><p>Loading admin panel...</p></div>
    );
  }

  return (
    <div className="admin-panel-container">
      <div className="admin-header">
        <button className="btn-back" onClick={() => navigate('/dashboard')}>
          ← Back to Dashboard
        </button>
        <h1 className="admin-title">Admin Panel</h1>
      </div>

      <div className="admin-content">
        <div className="admin-section">
          <h2>System Administration</h2>
          <p>Welcome to the Admin Panel. Administrative features are currently under development.</p>

          <div className="admin-cards">
            <div className="admin-card">
              <div className="card-icon">👥</div>
              <h3>User Management</h3>
              <p>Manage system users, roles, and permissions</p>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/administration')}
              >
                Manage Users
              </button>
            </div>

            <div className="admin-card">
              <div className="card-icon">📊</div>
              <h3>Guest Activities</h3>
              <p>Generate individual guest activity reports</p>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/reports')}
              >
                View Reports
              </button>
            </div>

            <div className="admin-card">
              <div className="card-icon">📈</div>
              <h3>Timeline Report</h3>
              <p>View check-in/check-out trends over time</p>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/timeline-report')}
              >
                View Timeline
              </button>
            </div>

            <div className="admin-card">
              <div className="card-icon">✅</div>
              <h3>Data Completeness</h3>
              <p>Analyze guest profile completeness and data quality</p>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/data-completeness')}
              >
                View Analysis
              </button>
            </div>

            <div className="admin-card">
              <div className="card-icon">🔄</div>
              <h3>Data Sync</h3>
              <p>Manage CCB synchronization and data updates</p>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/admin/data-sync')}
              >
                Manage Sync
              </button>
            </div>

            <div className="admin-card">
              <div className="card-icon">📧</div>
              <h3>Guest Activity Email Reports</h3>
              <p>Send guest activity reports via email with optional PDF attachments</p>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/admin/guest-activity-email-reports')}
              >
                Manage Email Reports
              </button>
            </div>

            <div className="admin-card">
              <div className="card-icon">🚗</div>
              <h3>Guest Pickup Report</h3>
              <p>Per-guest pickup details (expected/actual time, vehicle info) by week, month, quarter, semi-annual, or annual</p>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/admin/guest-pickup-report')}
              >
                View Pickup Report
              </button>
            </div>

            <div className="admin-card">
              <div className="card-icon">🤝</div>
              <h3>Volunteer Activity Log</h3>
              <p>Volunteer check-in/out history with service, operator, notes, and CCB attendance status</p>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/admin/volunteer-activity-log')}
              >
                View Volunteer Activity
              </button>
            </div>

            <div className="admin-card">
              <div className="card-icon">🩺</div>
              <h3>Activity &amp; Error Logs</h3>
              <p>What users did and what failed on their device — including the browser, viewport, and connection behind each error</p>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/admin/activity-logs')}
              >
                View Logs
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
